import React from "react";
import { observer } from "mobx-react";
import { EmailVerificationCreateStore } from "../../store";
import { EmailVerificationCreateForm } from "./EmailVerificationCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type EmailVerificationCreateProps = {
  emailVerificationCreateStore: EmailVerificationCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const EmailVerificationCreate: React.FC<EmailVerificationCreateProps> =
  observer(
    ({ emailVerificationCreateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={emailVerificationCreateStore.isSaving} />
          <EmailVerificationCreateForm
            emailVerificationCreateStore={emailVerificationCreateStore}
            emailError={emailVerificationCreateStore.errors.email?.message}
            onEmailChange={(value: string) => {
              emailVerificationCreateStore.setEmailValue(value);
            }}
            email={emailVerificationCreateStore.entityValues.email}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={emailVerificationCreateStore.isProcessing}
            onSave={() =>
              emailVerificationCreateStore.saveNewEmailVerification()
            }
            onCancel={() =>
              emailVerificationCreateStore.cancelNewEmailVerification()
            }
          />
          <ErrorDialog
            open={emailVerificationCreateStore.errorDialogOpened}
            title={emailVerificationCreateStore.errorTitle}
            description={emailVerificationCreateStore.errorDescription}
            onClose={() => emailVerificationCreateStore.closeErrorDialog()}
          />
        </>
      );
    }
  );
